import(/* webpackMode: "eager" */ "/app/src/app/[locale]/testing-consulting/page.tsx");
